import React from "react";

const Moong = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Moong</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className="table table-striped table-bordered">
          <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>K - 851 [Released in 14.01.1982]</strong>
              </td>
            </tr>
            <tr>
              <td>6-8 kgs per acre.</td>
              <td>March to May and June to July</td>
              <td>
                In drought conditions, one or two irrigations are sufficient at
                the time of flowering.
              </td>
              <td>65-70 days.</td>
              <td>
                Suitable for sowing in Summer as well as Kharif season. Medium
                plant height, medium grain size and pods mature all at one time.
              </td>
              <td>3-4 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>MUSKAN [Released in 04.02.2004]</strong>
              </td>
            </tr>
            <tr>
              <td>6-8 kgs per acre in Kharif and 8-10 in Zaid.</td>
              <td>March and July.</td>
              <td>
                In drought conditions, one or two irrigations are sufficient at
                the time of flowering.
              </td>
              <td>75-80 days in summers and 70-75 days in zaid season.</td>
              <td>
                Resistant to mosaic disease and lodging. Plant height is around
                40-50 cm in Summer and 60-80 cm in Zaid season. Matures all at
                once in Zaid season.
              </td>
              <td>5-7.5 quintals per acre in Zaid and 5-5.5 in Kharif.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>ASHA [Released in 17.08.1993]</strong>
              </td>
            </tr>
            <tr>
              <td>6-8</td>
              <td>March to May and June to July.</td>
              <td>
                In drought conditions, one or two irrigations are sufficient at
                the time of flowering.
              </td>
              <td>65-70 days.</td>
              <td>
                Suitable for irrigated areas in Summer as well as Kharif season.
                Medium plant height and pods mature all at once.
              </td>
              <td>3-4 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>SML - 668 [Released in 12.03.2003]</strong>
              </td>
            </tr>
            <tr>
              <td>6-8</td>
              <td>
                March is most suitable, but can be sown in May, June and July as
                well.
              </td>
              <td>
                In drought conditions, one or two irrigations are sufficient at
                the time of flowering.
              </td>
              <td>60 days.</td>
              <td>
                Suitable for irrigated areas. Plant height is around 44.6 cm.
                Wide green leaves. Long pods on the upper portion of the plant.
              </td>
              <td>4-5 quintals per acre.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Moong;
